import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Observable } from 'rxjs';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { AngularFirestore } from 'angularfire2/firestore';
import * as _ from "lodash";
import * as moment from "moment";

@IonicPage()
@Component({
  selector: 'page-reports',
  templateUrl: 'reports.html',
})
export class ReportsPage {
  
  isApp: boolean = false;
  clinic_id: string;
  clinic_name: string;
  clinic: any;

  public preList: Observable<any[]>;

  gridApi;
  gridColumnApi;

  columnDefs;
  rowData;
  detailCellRendererParams;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private auth: AuthProvider,
    private database: DatabaseProvider,
    private afs: AngularFirestore
    ) {
    this.isApp = (!document.URL.startsWith('http') || document.URL.startsWith('http://localhost:80'));

    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database.getClinic(this.clinic_id).valueChanges().subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
          console.log("Full Clinic Info: ", this.clinic)
        }
      });

      this.columnDefs = [
        {
          headerName: "Type",
          cellRenderer: "agGroupCellRenderer",
          valueGetter: function getStatus(params) {
            if(params.data.type === 'supplies') {
              return "Supplies";
            }
            else if(params.data.type === 'rx') {
              return "RX";
            }
            else {
              return "RX";
            }
          }
        },
        {
          headerName: "Date",
          valueGetter: (params) => {
            return moment(params.data.createdAt.toDate()).format("MMM DD YYYY h:mm A") // 27 January 10:30 am
          }
        },
        {
          headerName: "Status",
          valueGetter: (params) => {
            if(params.data.status === 'Queued') {
              return "Submitted";
            }
          }
        },
        {
          headerName: "Order Link",
          field: "order_file",
          cellRenderer: (params) => {
            if(params.value)  {
              return '<a style="text-docoration: none;" target="_blank" href="' + params.value + '">View Order</a>';
            }
          }
        },
      ];

      this.detailCellRendererParams = {
        detailGridOptions: {
          columnDefs: [
            { field: "order_batch" },
            // { field: "direction" },
            // { field: "number" },
            // {
            //   field: "duration",
            //   valueFormatter: "x.toLocaleString() + 's'"
            // },
            // { field: "switchCode" }
          ],
          onFirstDataRendered(params) {
            params.api.sizeColumnsToFit();
          }
        },
        getDetailRowData: function(params) {
          params.successCallback(params.data.rx);
        }
      };

      this.getOrders();
    });
  }

  ionViewDidLoad() {
    console.log('Is App? ', this.isApp);
  }

  openPrescriptionImage(imageUrl)  {
    window.open(imageUrl, '_blank');
  }

  getOrders() {
    console.log(this.clinic_id);
    const status: string = null;
    this.preList = this.afs.collection(`orders`, ref => {
      //console.log(status)
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      query = query.where('clinic_id', '==', this.clinic_id);
      return query.orderBy("createdAt", "desc");
    })
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

    setTimeout(function() {
      var rowCount = 0;
      params.api.forEachNode(function(node) {
        node.setExpanded(rowCount++ === 1);
      });
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/reports.ts